import React, {useState, useEffect} from 'react';


const ProgressBar = ({className, value, text = '', nums = false, max, readonly = true, stroke}) => {

    let progress = value / max * 100;

    if (readonly) {
        if (progress <= 8) {
            return (
                <div className={`rounded-md border-2 border-gray-200 w-full relative bg-gray-100 ${className}`} style={{height: `${((stroke+1)/4)}rem`}}>
                    <div
                        className={`rounded-full bg-blue-600 z-2 min-w-8 absolute right-0 top-0`} style={{width:`${progress}%`, height: `${stroke/4}rem`}}>
                    </div>
                    {nums ? <span className={`text-sm text-white z-3 absolute top-2 right-3 font-bold`}>{value}</span> : null}
                    {nums ? <span className={`text-sm text-gray-700 z-1 absolute top-2 left-4 font-bold`}>{max} {text}</span>  : null}

                </div>
            );
        } else if (progress >= 90) {
            return (
                <div className={`rounded-md border-2 border-gray-200 w-full relative bg-gray-100 ${className}`} style={{height: `${((stroke+1)/4)}rem`}}>
                    <div
                        className={`rounded-full bg-blue-600 z-3 min-w-8 absolute right-0 top-0`} style={{width:`${progress}%`, maxWidth:'100%', height: `${stroke/4}rem`}}>
                    </div>
                    {nums ? <span className={`text-sm text-white z-2 absolute top-2 right-4 font-bold`}>{value} {text}</span> : null}
                </div>
            );
        }
        else {
            return (
                <div className={`rounded-md border-2 border-gray-200 h-10 w-full relative bg-gray-100 ${className}`}>
                    <div
                        className={`rounded-full bg-blue-600 z-3 min-w-8 absolute right-0 top-0 h-9`} style={{width:`${progress}%`, maxWidth:'100%'}}>
                    </div>
                    {nums ? <span className={`text-sm text-white z-2 absolute top-2 right-4 font-bold`}>{value} {text}</span> : null}
                    {nums ? <span className={`text-sm text-gray-700 z-1 absolute top-2 left-4 font-bold`}>{max} {text}</span> : null}
                </div>
            );
        }
    }
};

export default ProgressBar;
